import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/services/users/user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  constructor(private userService: UserService) {
  }

  ngOnInit() {
  }

  async currentUser(){
    // this.userService.user$.subscribe(u => {
    //   console.log(u);
    // });
    // let user = await this.userService.user$;
    // let user = await (await this.userService.loggedUser()).subscribe(result => {
    //   console.log('suscribe result ',result);
    // })
    let user = JSON.parse(sessionStorage.getItem('loggedUser'));
    console.log('logged user', user);
  }

}
